var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23389 15.9789C5.93701 14.65 4.39014 12.1656 4.39014 9.32031C4.39014 5.07578 7.83311 1.63281 12.0776 1.63281C16.3222 1.63281 19.7651 5.07578 19.7651 9.32031C19.7651 12.1656 18.2183 14.65 15.9214 15.9789V18.6953C15.9214 19.1102 15.5862 19.4453 15.1714 19.4453H8.98389C8.56904 19.4453 8.23389 19.1102 8.23389 18.6953V15.9789ZM9.26514 20.9453H14.8901C14.9933 20.9453 15.0776 21.0297 15.0776 21.1328V21.8828C15.0776 22.2977 14.7425 22.6328 14.3276 22.6328H9.82764C9.41279 22.6328 9.07764 22.2977 9.07764 21.8828V21.1328C9.07764 21.0297 9.16201 20.9453 9.26514 20.9453Z",
    fill: "#0070BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbFilled);
export default __webpack_public_path__ + "static/media/bulbFilled.7ac683438ea9215a3db27a44c7539fae.svg";
export { ForwardRef as ReactComponent };